import { Controller } from "@hotwired/stimulus"
import StarRating from 'star-rating.js'

export default class extends Controller {
  // static targets = ["toggleable"];

  connect() {
    console.log("Drawer Review Edit controller connected");
    this.initStarRating()
  }

  toggle(event) {
    event.preventDefault()
    console.log("Toggle drawer review");
    document.getElementById('review_form_edit').classList.toggle('hidden')
  }

  submit(event) {
    event.preventDefault()
    // Проставляем рейтинги
    let cleanliness = document.getElementById('rating-cleanliness-edit').getElementsByClassName('gl-star-rating--stars')[0].getAttribute('data-rating')
    let maintenance = document.getElementById('rating-maintenance-edit').getElementsByClassName('gl-star-rating--stars')[0].getAttribute('data-rating')
    let communication = document.getElementById('rating-communication-edit').getElementsByClassName('gl-star-rating--stars')[0].getAttribute('data-rating')
    let convenience = document.getElementById('rating-convenience-edit').getElementsByClassName('gl-star-rating--stars')[0].getAttribute('data-rating')
    let accuracy = document.getElementById('rating-accuracy-edit').getElementsByClassName('gl-star-rating--stars')[0].getAttribute('data-rating')
    document.getElementById('review_cleanliness_edit').value = cleanliness && cleanliness > 0 ? cleanliness : 5
    document.getElementById('review_maintenance_edit').value = maintenance && maintenance > 0 ? maintenance : 5
    document.getElementById('review_communication_edit').value = communication && communication > 0 ? communication : 5
    document.getElementById('review_convenience_edit').value = convenience && convenience > 0 ? convenience : 5
    document.getElementById('review_accuracy_edit').value = accuracy && accuracy > 0 ? accuracy : 5

    document.getElementById('form_for_review_edit').submit()
  }

  initStarRating() {
    new StarRating('.star-rating-cleanliness-edit', {
      maxStars: 5,
      clearable: true,
      tooltip: 'Выберите рейтинг',
    });

    new StarRating('.star-rating-maintenance-edit', {
      maxStars: 5,
      clearable: true,
      tooltip: 'Выберите рейтинг',
    });

    new StarRating('.star-rating-communication-edit', {
      maxStars: 5,
      clearable: true,
      tooltip: 'Выберите рейтинг',
    });
    new StarRating('.star-rating-convenience-edit', {
      maxStars: 5,
      clearable: true,
      tooltip: 'Выберите рейтинг',
    });
    new StarRating('.star-rating-accuracy-edit', {
      maxStars: 5,
      clearable: true,
      tooltip: 'Выберите рейтинг',
    });
  }
}
